/**
 * ApprovalStatusBadge.js
 *
 * Pill-style approval status badges (matches complaints list StatusBadge pills).
 * Used by AdminApprovalsTable, ApprovalsTable (Manager), and ApprovalModal.
 */

import React from 'react';
import '../../../../shared/components/common/Badges.css';

const STATUS_CONFIG = {
  in_draft: { label: 'In Draft', className: 'status-in_draft' },
  draft: { label: 'In Draft', className: 'status-in_draft' },
  pending: { label: 'Pending', className: 'status-pending' },
  approved: { label: 'Approved', className: 'status-approved' },
  rejected: { label: 'Rejected', className: 'status-rejected' },
};

/**
 * @param {'in_draft'|'draft'|'pending'|'approved'|'rejected'} status
 * @param {'small'|'medium'} size — small matches complaints list; medium for modals
 */
const ApprovalStatusBadge = ({ status = 'pending', size = 'small' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const sizeClass = size === 'medium' ? 'status-pill-md' : 'status-pill-sm';

  return (
    <span
      className={`status-pill ${sizeClass} ${config.className}`}
      title={config.label}
    >
      {config.label.toUpperCase()}
    </span>
  );
};

export default ApprovalStatusBadge;
